import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { CssData } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { CssModeTitle } from "../../../../Utils/Constants";

export default function CssMode() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader title={CssModeTitle} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={CssData} language="css">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
}
